import React from "react";
import { Typography } from "antd";

import colors from "../styles/globalColors";
const { Title: ATitle } = Typography;

export default (props: {
  children: any;
  style?: any;
  inline?: boolean;
  withSubtitle?: boolean;
}) => {
  const { children, style, inline, withSubtitle } = props;

  let subtitleStyle = {};
  if (withSubtitle) {
    subtitleStyle = {
      marginBottom: 0
    };
  }

  return (
    <ATitle
      style={{
        color: colors.black,
        display: inline ? "inline-block" : "inherit",
        fontWeight: "lighter",
        ...subtitleStyle,
        ...style
      }}
    >
      {children}
    </ATitle>
  );
};
